import * as types from './mutation_types'

export default {
  [types.RESET_STATE] (state) {
    Object.assign(state, {
      deliveryDays: [],
      isLoading: false,
    })
  },

  [types.SET_DELIVERY_DAYS_LIST] (state, data) {
    state.deliveryDays = data
  },

  [types.IS_LOADING] (state, data) {
    if (data === undefined) {
      state.isLoading = !state.isLoading
    } else {
      state.isLoading = data
    }
  },

  [types.SET_PACK_PROPERTIES] (state, propeties) {
    state.packProperties = propeties
  },

  [types.SET_FILTERS] (state, filters) {
    state.filters = filters
  },

  [types.SET_PROMO_FILTERS] (state, filters) {
    state.promoFilters = filters
  },

  [types.SET_UNAUTHORIZED_FILTERS] (state, unauthorizedFilters) {
    state.unauthorizedFilters = unauthorizedFilters
  },

  [types.SET_APPLIED_UNAUTHORIZED_FILTERS] (state, appliedUnauthorizedFilters) {
    state.appliedUnauthorizedFilters = appliedUnauthorizedFilters
  },

  [types.SET_UNAUTHORIZED_LAST_FILTER_IDS] (state, filterIds) {
    state.unauthorizedFilterIds = filterIds
  },

  [types.SET_MAX_ACTIVE_FILTERS_COUNT] (state, value) {
    state.maxActiveFiltersCount = value
  },

  [types.SET_PROPOSED_FILTERS_VERSION] (state, value) {
    state.setProposedFiltersVersion = value
  },

  [types.SET_UPDATE_FILTERS_MODAL_VISIBLE] (state, value) {
    state.isUpdateFiltersModalVisible = value
  },
}
